import React, { memo } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "../../utils/link";
import { graphql, useStaticQuery } from "gatsby";

const JoinBushBuck = () => {
  const { joinclub } = useStaticQuery(graphql`
    {
      joinclub: contentfulHeaderWithBgImage(
        contentful_id: { eq: "4zB3tF28FOoYdLldySVw8T" }
      ) {
        title
        description {
          description
        }
        buttonText
        buttonLink
        backgroundImage {
          gatsbyImageData(
            formats: WEBP
            layout: FULL_WIDTH
            placeholder: DOMINANT_COLOR
          )
          title
        }
      }
    }
  `);

  return (
    <div className="w-screen flex flex-wrap h-full text-white relative overflow-y-hidden box-border">
      {joinclub.backgroundImage?.gatsbyImageData && (
        <div className="absolute block top-0 left-0 w-full h-full border-inherit overflow-hidden">
          <GatsbyImage
            image={joinclub.backgroundImage.gatsbyImageData}
            alt={joinclub.backgroundImage.title}
            objectFit="cover"
            objectPosition="center"
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="relative flex w-full flex-col justify-center items-center z-[2] pt-[90px] px-5 pb-5 box-border bg-black/30">
        <div className="relative w-full h-fit max-w-[1200px] py-20 lg:px-[60px]">
          <h2 className="text-[40px] md:text-[62px] tracking-[0.4px] leading-[60px] md:leading-[93px] lg:text-center font-bold">
            {joinclub.title}
          </h2>
          <p className="text-base leading-7 tracking-[0.4px] max-w-[500px] lg:mx-auto lg:text-center mt-5 mb-11">
            {joinclub.description.description}
          </p>
          <div className="flex flex-col lg:flex-row justify-center items-start lg:items-center lg:mt-[30px] text-center border-inherit">
            <Link
              to={joinclub.buttonLink}
              className=" rounded-full no-underline text-[#1f1f1f] lg:mx-auto text-[15px] font-bold tracking-[1px]
              leading-7 hover:scale-105 transition-all duration-200 ease-linear bg-white flex items-center justify-center px-9 py-3"
            >
              {joinclub.buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(JoinBushBuck);
